<template>
    <div>
        <b-form @submit.prevent="validateForm()"
                data-vv-scope="properties"
                v-if="product.properties"
        >
            <b-row v-if="!only_view">
                <b-col>
                    <b-alert variant="success"
                            show
                    >
                        <b-row>
                            <b-col lg="9"
                                md="6"
                                class="pt-2 pt-md-0 pt-lg-1"
                            >
                                <i class="fa fa-info"></i>
                                Relacione las propiedades físicas y químicas de las cuales tenga datos.
                            </b-col>
                            <b-col lg="3"
                                md="6"
                                class="pt-1 pt-md-1 pt-lg-0 filter-search-form-calc"
                            >
                                <b-form-input id="search"
                                            name="search"
                                            type="text"
                                            data-vv-as=" "
                                            placeholder="Buscar propiedades"
                                            v-model="filter"
                                            autocomplete="off"
                                            class="filter-search-form-calc-input"
                                />
                                <i class="fa fa-search filter-search-form-calc-icon"/>
                                <i v-if="!!filter.length"
                                @click="filter = ''"
                                title="Cancelar, y restablecer datos."
                                class="fa fa-close filter-search-form-calc-icon-cancel cursor-pointer"
                                />
                            </b-col>
                        </b-row>
                    </b-alert>
                </b-col>
            </b-row>

            <b-row v-for="(properties, i) in filteredProperties"
                :key="i"
            >
                <b-col cols="12"
                    class="mt-2"
                >
                    <h4 class="text-primary">
                        {{ properties.text }}
                    </h4>
                    <hr>
                </b-col>
                
                <b-col cols="12"
                    v-if="!properties.list.length"
                    class="text-center text-muted"
                >
                    <i class="fa fa-warning"></i> No se encontraron propiedades con el criterio de búsqueda "{{ filter }}"
                </b-col>

                <b-col v-for="(property, j) in properties.list"
                    :key="j"
                    md="3"
                    sm="6"
                    cols="12"
                >
                    <b-form-group
                        v-b-popover.html.hover.top.v-danger="errors.has(`properties.${property.key}`) ? errors.first(`properties.${property.key}`) : ''">
                        <label :for="property.key"
                            v-bind:class="{'text-danger' : errors.has(`properties.${property.key}`)}"
                        >
                            <span v-if="errors.has(`properties.${property.key}`)">
                                <i class="fa fa-exclamation-circle"></i>
                            </span>
                            {{ property.label }}
                            <span v-if="property.note"
                                class="text-warning"
                            >
                                <i class="fa fa-info-circle"
                                v-b-popover.html.hover.top="property.note"
                                />
                            </span>
                        </label>
                        <b-input-group size="sm">
                            <b-form-input :id="property.key"
                                        :name="property.key"
                                        type="text"
                                        v-model="product.properties[property.key]"
                                        :readonly="only_view"
                                        data-vv-as=" "
                                        v-validate="property.rules"
                                        size="small"
                                        autocomplete="off"
                                        @input="updateProperty(property.key)"
                                        v-bind:class="{'border-danger text-danger' : errors.has(`properties.${property.key}`)}"
                            />
                            <b-input-group-append>
                                <b-button :variant="errors.has(`properties.${property.key}`) ? 'danger' : 'secondary'"
                                        :id="'popover-calc-' + property.key"
                                        v-if="property.conversion"
                                        @click="openUnitConverter(property)"
                                >
                                    <i class="fa fa-calculator"></i>
                                </b-button>

                                <el-tooltip effect="dark"
                                            content="NO APLICA"
                                            placement="bottom"
                                >
                                    <b-button :variant="variantDoesNotApply(property.key)"
                                            @click="setValue(property.key, 'NO APLICA')"
                                    >
                                        N/A
                                    </b-button>
                                </el-tooltip>

                                <el-tooltip effect="dark"
                                            content="NO SE TIENE INFORMACIÓN"
                                            placement="bottom"
                                >
                                    <b-button :variant="variantThereIsNoInformation(property.key)"
                                            @click="setValue(property.key, 'NO SE TIENE INFORMACIÓN')"
                                    >
                                        N/I
                                    </b-button>
                                </el-tooltip>

                                <b-popover
                                    v-if="property.conversion"
                                    :target="'popover-calc-' + property.key"
                                    triggers="click"
                                    placement="right"
                                    container="body"
                                    custom-class="custom-popover-calc"
                                >
                                    <template #title>
                                        {{ property.label }}
                                    </template>
                                    <unit_converter ref="unit_converter"
                                                    :conversion_type="property.conversion.conversion_type"
                                                    :target_unit="property.conversion.target_unit"
                                                    @setValue="setValueFromConverter"
                                    />
                                </b-popover>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <!-- BLOQUE DE PROPIEDADES PERSONALIZADAS -->
            <b-row>
                <b-col cols="12" class="mt-2">
                    <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
                        <h4 class="text-primary mb-2 mb-md-0">
                            Propiedades Personalizadas
                        </h4>
                        <b-button variant="primary" @click="openCustomPropertyModal()">
                            <i class="fa fa-plus text-white fa-lg mr-1"></i> Agregar propiedad
                        </b-button>
                    </div>
                    <hr>
                </b-col>               
                               
                <b-col 
                        v-if="product.custom_properties && product.custom_properties.length > 0"
                        v-for="(property, j) in product.custom_properties"
                        :key="j"
                        md="3"
                        sm="6"
                        cols="12"
                        class="d-flex align-items-center mb-2"
                >
                
                    <b-form-group class="mb-0 w-100">
                        <label class="d-flex justify-content-between align-items-center w-100">
                            <span>{{ property.name }}</span>
                        </label>
                        <b-input-group size="sm">
                            <b-form-input 
                                :value="property.value" 
                                readonly 
                                size="sm"
                                class="bg-light text-dark-readonly"
                            />
                            <b-input-group-append v-if="!only_view">
                                <b-button 
                                    size="sm" 
                                    variant="outline-primary" 
                                    @click="openCustomPropertyModal(property)"
                                    title="Editar propiedad"
                                >
                                    <i class="fa fa-edit"></i>
                                </b-button>
                                <b-button 
                                    size="sm" 
                                    variant="outline-danger" 
                                    @click="handleDeleteCustomProperty(property)"
                                    title="Eliminar propiedad"
                                >
                                    <i class="fa fa-trash"></i>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>

                <b-col 
                    v-if="!product.custom_properties || product.custom_properties.length === 0"
                    cols="12" 
                    class="text-center text-muted"
                >
                    <i class="fa fa-info-circle"></i> No hay propiedades personalizadas. Haz clic en "Agregar propiedad" para crear una.
                </b-col>
            </b-row>

            <b-row v-if="!only_view">
                <b-col cols="12"
                    class="text-center"
                >
                    <hr>
                    <b-alert :show="!propertiesFilled"
                            variant="warning"
                    >
                        <strong>¡Atención!</strong> Para continuar, es necesario que haya diligenciado todas las propiedades físicoquímicas. Por favor, complete esta información antes de avanzar.
                    </b-alert>
                    <b-button @click="validateForm"
                            variant="primary"
                            class="mr-1"
                            size="sm"
                    >
                        <i class="fa fa-save"></i> Guardar
                    </b-button>
                </b-col>
            </b-row>
        </b-form>

        <!-- Modal para crear/editar propiedades personalizadas -->
        <b-modal id="modal-custom-property"
                    title="Propiedad Personalizada"
                    @ok="saveCustomProperty"
                    @cancel="closeCustomPropertyModal"
                    @hidden="closeCustomPropertyModal"
                    ok-title="Guardar"
                    cancel-title="Cancelar"
                    centered
                    size="lg"
        >
            <b-form-group label="Nombre de la Propiedad">
                <b-form-input v-model="customPropertyForm.name"
                                :state="errors.has('customPropertyForm.name') ? false : null"
                ></b-form-input>
                <b-form-invalid-feedback :state="errors.has('customPropertyForm.name') ? false : null">
                    {{ errors.first('customPropertyForm.name') }}
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Valor">
                <b-form-input v-model="customPropertyForm.value"
                                :state="errors.has('customPropertyForm.value') ? false : null"
                ></b-form-input>
                <b-form-invalid-feedback :state="errors.has('customPropertyForm.value') ? false : null">
                    {{ errors.first('customPropertyForm.value') }}
                </b-form-invalid-feedback>
            </b-form-group>
        </b-modal>   
        <!-- Fin del modal para crear/editar propiedades personalizadas -->

    </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import VeeValidate from 'vee-validate';
import Swal from 'sweetalert2';
import unit_converter from './unit_converter.vue';

// Función común para validar el formato y el rango
const validateCommon = (value) => {
    // Expresión regular para validar el formato
    const regex = /^([<>]? ?-?\d+(\.\d+)?|(-?\d+(\.\d+)? ?[aA] ?-?\d+(\.\d+)?))$/;

    // Verifica si el valor coincide con el formato esperado
    if (!regex.test(value) && value !== 'NO APLICA' && value !== 'NO SE TIENE INFORMACIÓN') {
        return {isValid: false, numbers: null};
    }

    // Extrae los números del valor
    const numbers = value.match(/-?\d+(\.\d+)?/g);

    // Si no hay números, es válido (caso de "NO APLICA" o "NO SE TIENE INFORMACIÓN")
    if (!numbers) {
        return {isValid: true, numbers: null};
    }

    // Convierte los números a valores numéricos
    const numericValues = numbers.map(Number);

    // Si es un rango, verifica que el primer número sea menor que el segundo
    if (numbers.length === 2) {
        const [first, second] = numericValues;
        if (first >= second) {
            return {isValid: false, numbers: null}; // El primer número no es menor que el segundo
        }
    }

    return {isValid: true, numbers: numericValues};
};

// Extensión personalizada de VeeValidate para validar propiedades del producto
VeeValidate.Validator.extend('property_product', {
    getMessage: () => `
        <strong>El valor debe cumplir con alguna de las siguientes condiciones:</strong>
        <ul class="mb-1">
            <li><strong>Número entero o decimal</strong> (separado por punto).</li>
            <li><strong>Rango de números</strong> usando la letra <code>"A"</code> (Ejemplo: <code>2 A 6</code>).</li>
            <li>Incluir <strong>signos de comparación</strong> (<code>&lt;</code> o <code>&gt;</code>) con <strong>máximo un espacio</strong> antes del número (Ejemplo: <code>&gt;6</code> o <code>&gt; 6</code>).</li>
            <li><strong>Valores negativos</strong> (Ejemplo: <code>-3.5</code>).</li>
            <li>Valores específicos: <code>NO SE TIENE INFORMACIÓN</code> o <code>NO APLICA</code>.</li>
        </ul>
        <strong>✅ Ejemplos válidos:</strong>
        <code>5</code>, <code>3.14</code>, <code>-7</code>, <code>2 a 8</code>, <code>4 A 9</code>, <code>&lt;10</code>, <code>&gt;4.5</code>, <code>-1 a 5</code>.
    `,
    validate: (value) => {
        const {isValid} = validateCommon(value);
        return isValid;
    }
});

// Extensión personalizada de VeeValidate para validar el pH
VeeValidate.Validator.extend('ph_validation', {
    getMessage: () => `
    <strong>El valor debe cumplir con alguna de las siguientes condiciones:</strong>
    <ul class="mb-1">
        <li><strong>Número entero o decimal</strong> (separado por punto) <strong>entre 0 y 14</strong></li>
        <li><strong>Rango de números</strong> usando la letra <code>"A"</code> (Ejemplo: <code>2 A 6</code>).</li>
        <li>Incluir <strong>signos de comparación</strong> (<code>&lt;</code> o <code>&gt;</code>) con <strong>máximo un espacio</strong> antes del número (Ejemplo: <code>&gt;6</code> o <code>&gt; 6</code>).</li>
        <li>Valores específicos: <code>NO SE TIENE INFORMACIÓN</code> o <code>NO APLICA</code>.</li>
    </ul>
    <strong>✅ Ejemplos válidos:</strong>
    <code>0</code>, <code>5</code>, <code>13.5</code>, <code>2 a 8</code>, <code>4 A 9</code>, <code>&lt;10</code>, <code>&gt;4.5</code>, <code>0 a 14</code>.
    `,
    validate: (value) => {
        const {isValid, numbers} = validateCommon(value);

        // Si no es válido o no hay números, retorna el resultado
        if (!isValid || !numbers) {
            return isValid;
        }

        // Válida que todos los números estén dentro del rango de 0 a 14
        for (const num of numbers) {
            if (num < 0 || num > 14) {
                return false;
            }
        }

        return true;
    }
});

export default {
    name: 'index',
    components: {unit_converter},
    data() {
        return {
            filter: '',
            conversion_type: '',
            target_unit: '',
            active_key: '',
            properties_list: [
                {
                    text: 'Propiedades generales',
                    list: [
                        {
                            key: 'color',
                            label: 'Color',
                            rules: 'min:1|max:60'
                        },
                        {
                            key: 'smell',
                            label: 'Olor',
                            rules: 'min:1|max:60'
                        },
                        {
                            key: 'melting_point',
                            label: 'Punto de fusión (°C)',
                            rules: 'property_product',
                            conversion: {
                                conversion_type: 'temperatura',
                                target_unit: '°C'
                            },
                            states: ['Solido', 'Liquido']
                        },
                        {
                            key: 'freezing_point',
                            label: 'Punto de congelación (°C)',
                            rules: 'property_product',
                            conversion: {
                                conversion_type: 'temperatura',
                                target_unit: '°C'
                            },
                            states: ['Solido', 'Liquido']
                        },
                        {
                            key: 'boiling_point',
                            label: 'Punto de ebullición (°C)',
                            rules: 'property_product',
                            conversion: {
                                conversion_type: 'temperatura',
                                target_unit: '°C'
                            },
                            states: ['Liquido']
                        },
                        {
                            key: 'inflammability',
                            label: 'Inflamabilidad',
                            rules: ''
                        },
                        {
                            key: 'lower_explosion_limit',
                            label: 'Límite inferior de explosión (%Vol)',
                            rules: 'property_product',
                            states: ['Liquido', 'Gaseoso']
                        },
                        {
                            key: 'upper_explosion_limit',
                            label: 'Límite superior de explosión (%Vol)',
                            rules: 'property_product',
                            states: ['Liquido', 'Gaseoso']
                        },
                        {
                            key: 'flash_point',
                            label: 'Punto de inflamación (°C)',
                            rules: 'property_product',
                            conversion: {
                                conversion_type: 'temperatura',
                                target_unit: '°C'
                            },
                            states: ['Liquido']
                        },
                        {
                            key: 'autoignition_temperature',
                            label: 'Temperatura de ignición espontánea (°C)',
                            rules: 'property_product',
                            conversion: {
                                conversion_type: 'temperatura',
                                target_unit: '°C'
                            },
                            states: ['Liquido', 'Gaseoso']
                        },
                        {
                            key: 'decomposition_temperature',
                            label: 'Temperatura de descomposición (°C)',
                            rules: 'property_product',
                            conversion: {
                                conversion_type: 'temperatura',
                                target_unit: '°C'
                            }
                        },
                        {
                            key: 'ph',
                            label: 'pH',
                            rules: 'ph_validation',
                            states: ['Solido', 'Liquido']
                        },
                        {
                            key: 'kinematic_viscosity',
                            label: 'Viscosidad cinemática a 40°C (mm²/s)',
                            rules: 'property_product',
                            conversion: {
                                conversion_type: 'viscosidadCinematica',
                                target_unit: 'mm²/s'
                            },
                            states: ['Liquido']
                        },
                        {
                            key: 'dynamic_viscosity',
                            label: 'Viscosidad dinámica (mPa.s)',
                            rules: 'property_product',
                            conversion: {
                                conversion_type: 'viscosidadDinamica',
                                target_unit: 'mPa·s'
                            },
                            states: ['Liquido']
                        },
                        {
                            key: 'solubility',
                            label: 'Solubilidad',
                            rules: ''
                        },
                        {
                            key: 'vapor_pressure',
                            label: 'Presión de vapor (hPa)',
                            rules: 'property_product',
                            conversion: {
                                conversion_type: 'presion',
                                target_unit: 'hPa'
                            }
                        },
                        {
                            key: 'relative_density',
                            label: 'Densidad relativa (g/cm³)',
                            rules: 'property_product',
                            conversion: {
                                conversion_type: 'densidad',
                                target_unit: 'g/cm³'
                            },
                            states: ['Liquido', 'Gaseoso']
                        },
                        {
                            key: 'relative_vapor_density',
                            label: 'Densidad de vapor relativa (Kg/m³)',
                            rules: 'property_product',
                            conversion: {
                                conversion_type: 'densidad',
                                target_unit: 'kg/m³'
                            },
                            states: ['Liquido', 'Gaseoso']
                        },
                        {
                            key: 'particle_characteristics',
                            label: 'Características de las partículas',
                            rules: 'property_product',
                            note: `
                                <ul>
                                    <li>Aplicable únicamente a líquidos.</li>
                                    <li>Indicar el tamaño de las partículas (mediana y rango).</li>
                                    <li>Si es posible y relevante, se pueden incluir propiedades adicionales, como:</li>
                                    <ul>
                                        <li>Distribución del tamaño de partículas (rango).</li>
                                        <li>Forma y relación de aspecto.</li>
                                        <li>Superficie específica.</li>
                                    </ul>
                                </ul>
                            `,
                            states: ['Liquido']
                        }
                    ]
                },
                {
                    text: 'Otras propiedades',
                    list: [
                        {
                            key: 'heat_value',
                            label: 'Valor de calor',
                            rules: 'property_product'
                        },
                        {
                            key: 'particle_size',
                            label: 'Tamaño de partícula',
                            rules: 'property_product',
                            states: ['Solido']
                        },
                        {
                            key: 'volatile_organic_compound_content',
                            label: 'Contenido de compuestos orgánicos volátiles',
                            rules: 'property_product'
                        },
                        {
                            key: 'softening_point',
                            label: 'Punto de ablandamiento',
                            rules: 'property_product',
                            states: ['Solido']
                        },
                        {
                            key: 'pour_point',
                            label: 'Pour point',
                            rules: 'property_product',
                            states: ['Liquido']
                        },
                        {
                            key: 'apparent_density',
                            label: 'Densidad aparente',
                            rules: 'property_product'
                        },
                        {
                            key: 'volatility_percentage',
                            label: 'Porcentaje de volatilidad',
                            rules: 'property_product'
                        },
                        {
                            key: 'saturated_vapor_concentration',
                            label: 'Concentración del vapor saturado',
                            rules: 'property_product'
                        },
                        {
                            key: 'molecular_weight',
                            label: 'Peso molecular (g/mol)',
                            rules: 'property_product'
                        },
                        {
                            key: 'molecular_formula',
                            label: 'Fórmula molecular',
                            rules: 'min:1|max:60'
                        },
                        {
                            key: 'acid_alkaline_reserve',
                            label: 'Reserva ácida-alcalina',
                            rules: 'property_product',
                            states: ['Liquido']
                        },
                        {
                            key: 'octanol_water_partition_coefficient',
                            label: 'Coeficiente de partición octanol/agua',
                            rules: 'property_product'
                        },
                        {
                            key: 'bioconcentration_factor',
                            label: 'Factor de bioconcentración',
                            rules: 'property_product'
                        },
                        {
                            key: 'dbo5',
                            label: 'DBO5',
                            rules: 'property_product'
                        },
                        {
                            key: 'dqo',
                            label: 'DQO',
                            rules: 'property_product'
                        }
                    ]
                }
            ],
            customPropertyForm: {         
                id: null,
                name: '',
                value: ''
            },
            isEditingCustomProperty: false, 
            customPropertyToDelete: null,
        };
    },
    mounted() {
        this.setDefaultValues();
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    computed: {
        ...mapState('calculator', ['product', 'only_view']),
        filteredProperties() {
            if (!this.filter) {
                return this.properties_list
                    .map(pl => ({
                        ...pl,
                        list: pl.list.filter(p => this.validateVisibility(p.key))
                    }));
            }

            const normalizeText = (text) => {
                return text
                    .toString()
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .replace(/[^a-zA-Z0-9\s]/g, '')
                    .toLowerCase();
            };

            const search = normalizeText(this.filter);

            return this.properties_list
                .map(pl => ({
                    ...pl,
                    list: pl.list.filter(p => normalizeText(p.label).includes(search) && this.validateVisibility(p.key))
                }));
        },
        propertiesFilled() {
            for (const key in this.product.properties) {
                if (this.product.properties[key] === null || this.product.properties[key] === '') {
                    return false;
                }
            }
            return true;
        }
    },
    methods: {
        ...mapActions('calculator', ['saveProperties', 'createCustomProperty', 'updateCustomProperty', 'deleteCustomProperty']),
        ...mapMutations('calculator', ['setPropertiesToProduct', 'setShowToModalConverter']),
        setDefaultValues() {
            if (!this.product.state) return;

            let properties = {...this.product.properties};

            this.properties_list.forEach((list) => {
                list.list.forEach((item) => {
                    if (item.hasOwnProperty('states')) {
                        if (!item.states.includes(this.product.state.lista)) {
                            properties[item.key] = 'NO APLICA';
                        }
                    }
                });
            });

            this.setPropertiesToProduct(properties);
        },
        validateVisibility(key) {
            let visibility = true;

            if (this.product.state) {
                this.properties_list.forEach((list) => {
                    list.list.forEach((item) => {
                        if (item.key === key && item.hasOwnProperty('states')) {
                            if (!item.states.includes(this.product.state.lista)) {
                                visibility = false;
                            }
                        }
                    });
                });
            }

            return visibility;
        },
        openUnitConverter(property) {
            this.conversion_type = property.conversion.conversion_type;
            this.target_unit = property.conversion.target_unit;
            this.active_key = property.key;
        },
        handleClickOutside(event) {
            this.properties_list.forEach(pl => {
                pl.list.forEach(item => {
                    if (item.conversion) {
                        const targetId = 'popover-calc-' + item.key;
                        const button = document.getElementById(targetId);
                        if (button) {
                            const popoverId = button.getAttribute('aria-describedby')
                            const popoverEl = popoverId ? document.getElementById(popoverId) : null
                            if (popoverEl &&
                                !button.contains(event.target) &&
                                !popoverEl.contains(event.target)) {
                                this.$root.$emit('bv::hide::popover', targetId)
                            }
                        }
                    }
                });
            });
        },
        setValueFromConverter(value) {
            this.$set(this.product.properties, this.active_key, value);
            this.validate();

            const targetId = 'popover-calc-' + this.active_key

            this.$root.$emit('bv::hide::popover', targetId)
        },
        validate() {
            this.$validator.validateAll('properties');
        },
        async validateForm() {
            this.setDefaultValues();

            this.filter = '';
            setTimeout(() => {
                this.$validator.validateAll('properties')
                    .then(async (result) => {
                        if (result) {
                            await this.saveProperties();
                        }
                    });
            });
        },
        async setValue(key, value) {
            const current_value = this.product.properties[key];

            if (value === current_value) return;

            const property = this.properties_list
                .flatMap(pl => pl.list)
                .find(p => p.key === key);

            if (!property) return;

            const updateProperty = () => {
                this.$set(this.product.properties, key, value);
                setTimeout(() => this.$validator.validateAll('properties'));
            };

            if (current_value && !['NO APLICA', 'NO SE TIENE INFORMACIÓN'].includes(current_value)) {
                const result = await Swal.fire({
                    title: '',
                    text: `¿Está seguro de cambiar el valor de ${property.label} a ${value}?`,
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Sí, cambiar'
                });

                if (result.isConfirmed) updateProperty();
            } else {
                updateProperty();
            }
        },
        variantDoesNotApply(key) {
            if (this.errors.has(`properties.${key}`)) {
                return 'outline-danger';
            }
            return this.product.properties[key] === 'NO APLICA' ? 'custom-info' : 'custom-outline-info';
        },
        variantThereIsNoInformation(key) {
            if (this.errors.has(`properties.${key}`)) {
                return 'outline-danger';
            }
            return this.product.properties[key] === 'NO SE TIENE INFORMACIÓN' ? 'primary' : 'outline-primary';
        },
        updateProperty(key) {
            let properties = {...this.product.properties};
            properties[key] = properties[key].toUpperCase();
            this.setPropertiesToProduct(properties);

            setTimeout(() => this.$validator.validate(`properties.${key}`));
        },      
        openCustomPropertyModal(property = null) {
            if (property) {
                this.isEditingCustomProperty = true;
                this.customPropertyForm = { ...property };
            } else {
                this.isEditingCustomProperty = false;
                this.customPropertyForm = { id: null, name: '', value: '' };
            }
            this.$bvModal.show('modal-custom-property');
        },
        closeCustomPropertyModal() {
            this.$bvModal.hide('modal-custom-property');
        },
        async saveCustomProperty() {
            const { id, name, value } = this.customPropertyForm;            
            
            if (!name.trim()) {
                Swal.fire('Error', 'El nombre de la propiedad es requerido.', 'error');
                return;
            }
            
            if (!value.trim()) {
                Swal.fire('Error', 'El valor de la propiedad es requerido.', 'error');
                return;
            }

            try {          
                // Si es edición, actualiza la propiedad.
                if (this.isEditingCustomProperty) {
                    const updateData = { id, name: name.trim(), value: value.trim() };
                    await this.updateCustomProperty(updateData);
                } else {
                    // Si es creación, crea la propiedad.
                    const createData = { name: name.trim(), value: value.trim() };
                    await this.createCustomProperty(createData);
                }
                
                this.closeCustomPropertyModal();                
               
            } catch (error) {
                console.error('Error al guardar propiedad:', error);                
            }
        },
        async handleDeleteCustomProperty(property) {
            try {
                const result = await Swal.fire({
                    title: '¿Estás seguro?',
                    text: `¿Deseas eliminar la propiedad "${property.name}"?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Sí, eliminar',
                    cancelButtonText: 'Cancelar'
                });

                if (result.isConfirmed) {
                    await this.deleteCustomProperty({ id: property.id });          
                }
            } catch (error) {
                console.error('Error al eliminar propiedad:', error);               
            }
        },
               
    },
};
</script>

<style>
.custom-tooltip {
    max-width: 250px !important;
    white-space: normal !important;
    word-wrap: break-word !important;
    text-align: left !important;
}

.b-popover-danger.popover {
    background-color: #fff2f4;
    border-color: #ffcbca;
}

.filter-search-form-calc {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 100%;
}

.filter-search-form-calc-input {
    border: 1px solid #e1e3e1;
    border-radius: 5px;
    padding: 7px 2rem;
    width: 100%;
    outline: none;
}

.filter-search-form-calc-icon-cancel {
    position: absolute;
    right: 1.4rem;
    top: .65rem;
    color: #9c9c9c;
    font-size: 1.1rem;
}

.filter-search-form-calc-icon {
    position: absolute;
    left: 1.4rem;
    top: .6rem;
    color: #9c9c9c;
    font-size: 1.3rem;
}

.custom-popover-calc {
    max-width: 300px;
    transform: translateZ(0);
    backface-visibility: hidden;
    will-change: transform;
    box-shadow: 0 0 69px #858585;
    border: 1px solid #ffffff;
}

.btn-custom-info {
    color: #ffffff;
    background-color: #63afde;
    border-color: #63afde;
}

.btn-custom-outline-info {
    color: #63afde;
    background-color: #fff;
    border-color: #63afde;
}

.text-dark-readonly {
    color: #58616b !important;
    font-weight: 500;
}

</style>
